<template>
 <div>
 <table style="position: absolute;" width="100%"  :height="this.windowSize.height-8"  :max-height="this.windowSize.height-8" >
<tr max-height="48px" height="48px"  >
      
<ContenidoBase 
  :titulo="'COMPROBANTES EMITIDOS'"
  :descripcion="'COMPROBANTES EMITIDOS'"
   :EstadoBtn="EstadoBtn"
   @abrirBarraTablaDinamica="abrirTabla"
   @MethodNuevo="newwnuevo"
   @MethodGuardar="save"
   @MethodEliminar="remove"
   @MethodAnular="anular"
   @MethodImprimir="imprimirList"
   
/>
    </tr>


  
    <tr>
<!-- BarraPrimaria --------------------------------------------------------------------------------->
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraTablaDinamicaAprir">

         <div class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">
        
        <v-tooltip left>
          <template v-slot:activator="{ on }">
              <center>
              <v-btn-toggle>
                <v-btn
                  small
                  color="yellow accent-4"
                  @click.prevent="actualiza_tb_ver"
                >
                  <i style="font-size: 25px;" class="fa fa-eye"> </i> ver</v-btn
                >
                <v-btn
                  small
                  dark
                  color="deep-purple accent-2"
                  @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                >
                  <i style="font-size: 25px;" class="fa fa-print"> </i>
                  Listado</v-btn
                >
              </v-btn-toggle>
            </center>
            <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitReportesadminFacElet'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
          </template>
        </v-tooltip>

      </div>
      </td>
<!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
<!-- contenido central ------------------------------------------------------------------------------ -->
      <td :max-height="this.windowSize.height-96" >
        <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
 
<!-- Formulario-Generar Ventas del Dia -->
 <v-container >
  <v-card color="grey lighten-3">

<v-toolbar
        flat
        color="#BDBDBD"
        dense
        style="border: 1px solid #000000;"
      >
        
  
 <v-avatar tile  size="45"  >
      <img
        src="@/assets/iconos_micromarket/custom-reports.png"
        alt="Reporte"
      >
    </v-avatar>

    
<span class="font-weight-light" style="font-size: 20px;" > COMPROBANTES EMITIDOS </span >

  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
   <!-- style="color:white;" -->
    <!-- <i class=""> </i> -->

        <!-- <v-spacer></v-spacer> -->
        <!-- <v-btn
          color="grey darken-4"
          fab
          small
          @click="cerrarmodalcuenta"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn> -->
      </v-toolbar>
           
<hr>

  <v-container style="border: 1px solid #000000;">
  <v-form ref="form" @submit.prevent=""  v-model="valid" lazy-validation>
              <v-row>
<!-- columna 1 -->
<v-col cols="12" md="6" sm="6">
<!-- -----------------------------  Desde  -->
<v-text-field
        dense
        outlined
        type="date" 
         :rules="[$rules.required]" 
        label="Desde:"
        v-model="adminFacElet.desde"
        @blur="BlurDesde"
        class="fontSize13" 
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>
</v-text-field>
<center>
  <span style="font-size: 12px"><b>ESTADO FAC. ELECTRÓNICO:</b></span>
    <v-radio-group v-model="adminFacElet.opcion" class="pt-0 mt-0 d-flex justify-center " dense
                                       hide-details row >
                          <!-- <v-radio label="RUTINARIOS" color="green" :value="1"></v-radio>
                          <v-radio label="NO RUTINARIOS" color="green" :value="2"></v-radio>-->
                          <v-radio :value="1" color="blue" label="">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">TODOS</strong>
                            </template>
                          </v-radio>
                          <v-radio id="no-enviada" :value="2" color="green" label="">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">ACEPTADO</strong>
                            </template>
                          </v-radio>

                           <v-radio id="no-enviada" :value="3" color="orange" label="">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">REENVIADO</strong>
                            </template>
                          </v-radio>
                          <v-radio :value="4" color="red" label="">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">RECHAZADO</strong>
                            </template>
                          </v-radio>



                        </v-radio-group>
</center>

</v-col>
<!-- fn columna 1 -->


<!-- columna 2 -->
<v-col cols="12" md="6" sm="6">

<!-- -----------------------------  Hasta  -->
<v-text-field
        dense
        outlined
        type="date" 
         :rules="[$rules.required]" 
        label="Hasta:"
        v-model="adminFacElet.hasta"
        @blur="BlurHasta"
        class="fontSize13" 
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>

 </v-text-field>

 <v-text-field v-model="adminFacElet.ncf" autocomplete="off" dense hide-details label="NCF"
                                        outlined style="font-size: 12px;">
                            <template v-slot:prepend>
                              <i class="fa fa-barcode" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>


</v-col>
<!-- fn columna 2 -->


              
              </v-row>

            </v-form>
       </v-container>

<hr>

<ModalReporteFiltros
 ref="ModRepFilt"
@DataReporteBasico="DDataReporteBasico"
:Datos="adminFacElet"
:propsBtnImprimir="true" :propsBtnExel="true" :propsBtnCorreo="false"
/>


  </v-card>
 </v-container>
<!-- fn Formulario-Generar Ventas del Dia -->
        </v-app> 
      </td>
<!-- fn contenido central ------------------------------------------------------------------------------------->
<!-- BarraSecundaria ------------------------------------------------------------------------------------------>
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir" >

 <div  class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">
        
<!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
</div>

      </td>
<!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



    </tr>
  </table>
<!-- Modales -------------------------------------------------------------------------------------------------->
  <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      label="myAlert"
      v-model="acti_tb_data"
      persistent
      max-width="100%"
      max-height="100%"
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            fab
            small
            @click="acti_tb_data = !acti_tb_data"
          >
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                @keyup="filtro"
                label="Buscar"
                single-line
                hide-details
              >
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="slotHtabla"
              dense
              :items="list"
              :search="search"
              @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog
      label="myAlert"
      v-model="Elim_notif.estado"
      persistent
      max-width="350"
      transition="fab-transition"
    >
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            @click.prevent="
              eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            "
            small
          >
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%;"
      :vertical="true"
      :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

<!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import ContenidoBase from "../../components/ContenidoBase";
import ModalReporteFiltros from "../../components/ModalReporteFiltros2";
import { currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha
} from "@/js/Funciones.js";
export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ModalReporteFiltros
  },
  created() { 
    var json = { 
      titulo: "Generar Ventas del Dia",
      descripcion: "Generar Ventas del Dia",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      accion: [ 

        "ReportesadminFacEletNew",
        "ReportesadminFacEletSave",
        "ReportesadminFacEletRemove",
        "ReportesadminFacEletAnular",
        "ReportesadminFacEletPrintList"
      ], 
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  //mounted-carga de inicio
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    EventBus.$on("ReportesadminFacEletNew", this.new);
    EventBus.$on("ReportesadminFacEletSave", this.save);
    EventBus.$on("ReportesadminFacEletRemove", this.remove);
    EventBus.$on("ReportesadminFacEletAnular", this.remove);
    EventBus.$on("ReportesadminFacEletPrintList", this.imprimirList);
    EventBus.$on("emitReportesadminFacElet", this.datostabla);
    EventBus.$on("onResize", this.onResize);
    this.$refs.ModRepFilt.CrearObjecto=this.validarObjecto;
  },
  //mounted-carga de inicio
  data:()=>  ({


      Rpropietario:[],
      RCaja:[],
      ListaTiposClientes: [],
      windowSize:{width:"auto", height:"auto"},
      adminFacElet: {
      
        nombre:'COMPROBANTES EMITIDOS',
        UrlImprimir: '/reportes-adfa/ImprimirListAdminFacEletronico', 
        UrlExel: '/reportes-adfa/ExcelListAdminFacEletronico', 
        UrlCorreo: '/reportes-adfa/CorreoListAdminFacEletronico', 
        desde: fechaNueva(),
        hasta:fechaNueva(),
        opcion:1,
        ncf:""
        //fechaCreacion: new,
      //  fechaModificacion: "", 
      },

EstadoBtn:{ 
        BarraTablaDinamicaAprir:false,
        nuevo:false,
        guardar:false,
        eliminar:false,
        anular:false,
        imprimir:false,
        vercuenta:false,
        guardartemporal:false,
        restaurartemporal:false,
        importarDato:false,
        cargarProducto:false,
        ImprimirproductoInv:false,
        },

     
      text: "",
      valid: true,
     BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:"
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" }
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?"
      },

      aalert: {
        estado: false,
        color: null
      },
    
    }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
    currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha,
onResize(e){

console.log("imprii ")

console.log(e)
this.windowSize=e


},

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;

    },
    
    datostabla(e) {

      this.adminFacElet = e;
      this.acti_tb_data=false
    },
    save() {},
    remove() { },
    eliminar() {},
    anular() { },
    imprimirList() {},
    // Retorna los datos del componente ModalReporteFiltros
 DDataReporteBasico(){},

 // Creando una cadena sentencia sql 
    validarObjecto(){

      var fecdesde=this.adminFacElet.desde
      var fechasta=this.adminFacElet.hasta
//subqry.fechaemision::date >= '2025-10-01' and subqry.fechaemision::date  <='2026-03-02' and estado ilike'Aceptado' 
var where=` where subqry.fechaemision::date >= '${fecdesde}' and subqry.fechaemision::date <='${fechasta}'`
var condicion=`DESDE: ${this.FormatoFecha(fecdesde)}                    HASTA: ${this.FormatoFecha(fechasta)}  `;
// opcion:
// 1- TODOS
// 2- ACEPTADO
// 3- REENVIADO
// 4- RECHAZADO

if(this.adminFacElet.opcion==2){
where+=` and estado ilike'%Aceptado%' `
  condicion+=`\t\t ESTADO: ACEPTADO`
}
if(this.adminFacElet.opcion==3){
  where+=` and estado ilike'%Reenviado%' `
  condicion+=`\t\t ESTADO: REENVIADO `
}
if(this.adminFacElet.opcion==4){
  where+=` and estado ilike'%Rechazado%' `
  condicion+=`\t\t ESTADO: RECHAZADO`
}

if(this.adminFacElet.ncf!=null && this.adminFacElet.ncf.trim().length>0){
 where+=` and UPPER(encf) ilike'%${this.adminFacElet.ncf.trim().toUpperCase()}%' `
 condicion+=`\t\t NCF: ${this.adminFacElet.ncf.trim()}`
}


this.adminFacElet.where=where
this.adminFacElet.condicion=condicion

},

    newwnuevo() {
      (this.adminFacElet = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: ""
      }),
        EventBus.$emit("actualizaBarraBusqueda2");
    },



// Un método que se llama cuando la entrada pierde el foco y valida si el compo esta null
//si lo esta coloca la fecha actual.
BlurDesde(){
if(this.adminFacElet.desde.toString().length==0){
  this.adminFacElet.desde=this.fechaNueva() 
}
 },

// Un método que se llama cuando la entrada pierde el foco y valida si el compo esta null
//si lo esta coloca la fecha actual.
 BlurHasta(){
if(this.adminFacElet.hasta.toString().length==0){
  this.adminFacElet.hasta=this.fechaNueva()
}
 },

 alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
      }
    },




    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {
      await this.$axios
        .post(this.$hostname + this.$hName + "/services/tipocliente/findalltipoclientes", {
          usuario:JSON.parse(JSON.stringify(this.$user)) 
        })
        .then(res => {
          this.list = res.data;
        });
    }
  }
};
</script>

<style></style>
